$mol_svg_group $mol_svg
	dom_name \g
